// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Terms of Use dialog — dark by default, light via body.light_theme (same as user-agreement.css). */

.agcex-terms-overlay {
  position: fixed;
  inset: 0;
  z-index: 20000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  background: rgba(0, 0, 0, 0.72);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

.agcex-terms-modal {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 980px;
  max-height: 88vh;
  overflow: hidden;
  border: 1px solid #e2e8f01f;
  border-radius: 14px;
  background: #181a20;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
}

body.light_theme .agcex-terms-modal {
  border-color: #e2e8f0;
  background: #ffffff;
}

.agcex-terms-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex: 0 0 auto;
  padding: 16px 20px;
  border-bottom: 1px solid #e2e8f014;
}

body.light_theme .agcex-terms-modal__head {
  border-bottom-color: #e2e8f0;
}

.agcex-terms-modal__title {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #f0f0f0;
}

body.light_theme .agcex-terms-modal__title {
  color: #1e293b;
}

.agcex-terms-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  border: 1px solid #e2e8f01f;
  border-radius: 8px;
  background: transparent;
  font-size: 20px;
  line-height: 1;
  color: #f0f0f0;
  cursor: pointer;
}

.agcex-terms-modal__close:hover {
  background: #ffffff12;
}

body.light_theme .agcex-terms-modal__close {
  border-color: #e2e8f0;
  color: #1e293b;
}

body.light_theme .agcex-terms-modal__close:hover {
  background: #f1f5f9;
}

.agcex-terms-modal__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

/* The shared content is built for a full page, so drop its page-level spacing here. */
.agcex-terms-modal__body .hero-banner-style.top-section-gap {
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}

.agcex-terms-modal__body .user_agreement {
  padding-top: 0;
  padding-bottom: 16px;
}

.agcex-terms-modal__body .agcex-ua-card {
  border: 0;
  background: transparent;
}

.agcex-terms-modal__foot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 0 0 auto;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f014;
}

body.light_theme .agcex-terms-modal__foot {
  border-top-color: #e2e8f0;
}

.agcex-terms-modal__btn {
  min-width: 120px;
  padding: 10px 18px;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(135deg, #d1aa67, #f5c573);
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #181a20;
  cursor: pointer;
}

.agcex-terms-modal__btn:hover {
  filter: brightness(1.05);
}

.agcex-terms-modal__btn--ghost {
  border: 1px solid #e2e8f01f;
  background: transparent;
  color: #f0f0f0;
}

.agcex-terms-modal__btn--ghost:hover {
  background: #ffffff12;
  filter: none;
}

body.light_theme .agcex-terms-modal__btn--ghost {
  border-color: #e2e8f0;
  color: #1e293b;
}

body.light_theme .agcex-terms-modal__btn--ghost:hover {
  background: #f1f5f9;
}

@media (max-width: 767px) {
  .agcex-terms-overlay {
    padding: 12px 8px;
  }

  .agcex-terms-modal {
    max-height: 92vh;
  }

  .agcex-terms-modal__head,
  .agcex-terms-modal__foot {
    padding: 12px 14px;
  }

  .agcex-terms-modal__title {
    font-size: 17px;
  }

  .agcex-terms-modal__btn {
    min-width: 0;
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/UserTermsConditions/terms-modal.css"],"names":[],"mappings":"AAAA,oGAAoG;;AAEpG;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,sFAAsF;AACtF;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,qDAAqD;EACrD,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,SAAW;EACb;AACF","sourcesContent":["/* Terms of Use dialog — dark by default, light via body.light_theme (same as user-agreement.css). */\n\n.agcex-terms-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 20000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 16px;\n  background: rgba(0, 0, 0, 0.72);\n  backdrop-filter: blur(2px);\n}\n\n.agcex-terms-modal {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 980px;\n  max-height: 88vh;\n  overflow: hidden;\n  border: 1px solid #e2e8f01f;\n  border-radius: 14px;\n  background: #181a20;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n}\n\nbody.light_theme .agcex-terms-modal {\n  border-color: #e2e8f0;\n  background: #ffffff;\n}\n\n.agcex-terms-modal__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex: 0 0 auto;\n  padding: 16px 20px;\n  border-bottom: 1px solid #e2e8f014;\n}\n\nbody.light_theme .agcex-terms-modal__head {\n  border-bottom-color: #e2e8f0;\n}\n\n.agcex-terms-modal__title {\n  margin: 0;\n  font-family: \"Inter\", sans-serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: #f0f0f0;\n}\n\nbody.light_theme .agcex-terms-modal__title {\n  color: #1e293b;\n}\n\n.agcex-terms-modal__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  padding: 0;\n  border: 1px solid #e2e8f01f;\n  border-radius: 8px;\n  background: transparent;\n  font-size: 20px;\n  line-height: 1;\n  color: #f0f0f0;\n  cursor: pointer;\n}\n\n.agcex-terms-modal__close:hover {\n  background: #ffffff12;\n}\n\nbody.light_theme .agcex-terms-modal__close {\n  border-color: #e2e8f0;\n  color: #1e293b;\n}\n\nbody.light_theme .agcex-terms-modal__close:hover {\n  background: #f1f5f9;\n}\n\n.agcex-terms-modal__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* The shared content is built for a full page, so drop its page-level spacing here. */\n.agcex-terms-modal__body .hero-banner-style.top-section-gap {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n}\n\n.agcex-terms-modal__body .user_agreement {\n  padding-top: 0;\n  padding-bottom: 16px;\n}\n\n.agcex-terms-modal__body .agcex-ua-card {\n  border: 0;\n  background: transparent;\n}\n\n.agcex-terms-modal__foot {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  flex: 0 0 auto;\n  padding: 14px 20px;\n  border-top: 1px solid #e2e8f014;\n}\n\nbody.light_theme .agcex-terms-modal__foot {\n  border-top-color: #e2e8f0;\n}\n\n.agcex-terms-modal__btn {\n  min-width: 120px;\n  padding: 10px 18px;\n  border: 0;\n  border-radius: 8px;\n  background: linear-gradient(135deg, #d1aa67, #f5c573);\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 600;\n  color: #181a20;\n  cursor: pointer;\n}\n\n.agcex-terms-modal__btn:hover {\n  filter: brightness(1.05);\n}\n\n.agcex-terms-modal__btn--ghost {\n  border: 1px solid #e2e8f01f;\n  background: transparent;\n  color: #f0f0f0;\n}\n\n.agcex-terms-modal__btn--ghost:hover {\n  background: #ffffff12;\n  filter: none;\n}\n\nbody.light_theme .agcex-terms-modal__btn--ghost {\n  border-color: #e2e8f0;\n  color: #1e293b;\n}\n\nbody.light_theme .agcex-terms-modal__btn--ghost:hover {\n  background: #f1f5f9;\n}\n\n@media (max-width: 767px) {\n  .agcex-terms-overlay {\n    padding: 12px 8px;\n  }\n\n  .agcex-terms-modal {\n    max-height: 92vh;\n  }\n\n  .agcex-terms-modal__head,\n  .agcex-terms-modal__foot {\n    padding: 12px 14px;\n  }\n\n  .agcex-terms-modal__title {\n    font-size: 17px;\n  }\n\n  .agcex-terms-modal__btn {\n    min-width: 0;\n    flex: 1 1 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
